import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReferenceDisplayService } from './reference-display.service';

@Pipe({
  name: 'referenceIdentifier',
  standalone: true
})
export class ReferenceIdentifierPipe implements PipeTransform {
  private referenceDisplayService = inject(ReferenceDisplayService);

  transform(value: string | null | undefined): Observable<string> {
    if (!value) {
      return of('');
    }
    
    // ensureIdentifier returns an Observable<string> that resolves to the human-readable identifier
    return this.referenceDisplayService.ensureIdentifier(value);
  }
}
